import { isServer } from '@/helpers/Platform/Platform';
import { Auth0VueClient, useAuth0 } from '@auth0/auth0-vue';

export const useAuth0Client = (): Auth0VueClient | null => {
  if (isServer()) {
    return null;
  }

  return useAuth0();
};
